import Auth from "./Auth";

export default function Login() {
  return <Auth initialMode="login" />;
}
